import React from 'react';
import { withRouter } from 'react-router-dom';
import AddToHomeScreenScreen from '../components/AddToHomeScreenScreen';

const AddToHomeScreenView = (props) => {
    return <AddToHomeScreenScreen onClose={() => props.history.goBack()} />
};

export default withRouter(AddToHomeScreenView);